import axios from "axios";
import {
	BaseResponse,
	SchemeIssueMappingListResponse,
	SchemeIssueMappingPayload,
	SchemeIssueMappingResponse,
	SchemeIssueMappingSummaryResponse,
	SchemeIssueTree,
} from "../types/schemeIssueMapping.type";

export const fetchSchemeIssueMappings = async (
	page = 1,
	limit = 10,
	schemeId?: number | string | null,
	issueTypeId?: number | string | null,
): Promise<SchemeIssueMappingListResponse["data"]> => {
	const response = await axios.get(`/admin/scheme-issue-mapping/list`, {
		params: {
			page,
			limit,
			scheme_id: schemeId || undefined,
			issue_type_id:
				issueTypeId === null && issueTypeId !== undefined
					? "null"
					: issueTypeId || undefined,
		},
	});
	return response.data.data;
};

export const fetchSchemeIssueMappingSummary = async (): Promise<
	SchemeIssueMappingSummaryResponse["data"]
> => {
	const response = await axios.get(`/admin/scheme-issue-mapping/summary`);
	return response.data.data || [];
};

export const saveSchemeIssueMapping = async (
	payload: SchemeIssueMappingPayload,
): Promise<SchemeIssueMappingResponse> => {
	const response = await axios.post(
		`/admin/scheme-issue-mapping/add`,
		payload,
	);
	return response.data;
};

export const deleteSchemeIssueMapping = async (
	id: number | string,
): Promise<BaseResponse> => {
	const response = await axios.delete(
		`/admin/scheme-issue-mapping/delete/${id}`,
	);
	return response.data;
};

// Full issue tree (types → categories → sub categories, plus any
// no-type/direct categories) mapped to one scheme. Used to drive the
// Type/Category/Sub Category cascade in Scheme Data Entry.
export const fetchSchemeIssueMappingTree = async (
	schemeId: number | string,
): Promise<SchemeIssueTree> => {
	const response = await axios.get(`/admin/scheme-issue-mapping/tree`, {
		params: { scheme_id: schemeId },
	});
	return response.data.data;
};

// Removes one category (and its sub categories) from a mapping row.
export const removeMappingCategory = async (
	mappingId: number | string,
	categoryId: number | string,
): Promise<BaseResponse> => {
	const response = await axios.delete(
		`/admin/scheme-issue-mapping/${mappingId}/category/${categoryId}`,
	);
	return response.data;
};
